import React from 'react';

const About = () => {
  const danceStyles = [
    'Bollywood',
    'HipHop',
    'Fusion',
    'Salsa',
    'Bhangra',
    'Jazz',
    'Lyrical',
    'Street Dance'
  ];

  return (
    <section id="about" className="py-20 bg-light-pink">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-text-dark mb-4">
            About <span 
              style={{
                background: 'linear-gradient(90deg, #FC9C24, #E454B4, #5454B4, #0C9CCC)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
            >Offbeat Crew</span>
          </h2>
          <div className="w-24 h-1 mx-auto" style={{
            background: 'linear-gradient(90deg, #FC9C24, #E454B4, #5454B4, #0C9CCC)'
          }}></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-2xl font-semibold text-text-dark mb-4">
              Dance for the Joy of It
            </h3>
            <p className="text-text-dark opacity-80 mb-6 leading-relaxed">
              We're a collective of passionate dancers who came together with a simple mission: 
              to spread joy through performance. We believe dance should be inclusive, celebratory, and most importantly, fun!
            </p>
            <p className="text-text-dark opacity-80 mb-6 leading-relaxed">
              Unlike competitive dance groups, we focus on the pure joy of movement and the magic of surprising audiences 
              with spontaneous flash mobs across the Bay Area.
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-2xl border border-hot-pink/20">
            <h4 className="text-xl font-semibold text-text-dark mb-6 text-center">
              Our Dance Styles
            </h4>
            <div className="grid grid-cols-2 gap-3">
              {danceStyles.map((style, index) => (
                <div 
                  key={index}
                  className="bg-white px-4 py-3 rounded-lg text-center text-text-dark border border-hot-pink/30 card-hover"
                >
                  {style}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="p-8 rounded-2xl text-white text-center" style={{
          background: 'linear-gradient(120deg, #FC9C24 0%, #E454B4 35%, #5454B4 65%, #0C9CCC 100%)'
        }}>
          <h3 className="text-2xl font-bold mb-4" style={{textShadow: '0 2px 20px rgba(0,0,80,.2)'}}>
            Founded on Friendship & Passion
          </h3>
          <p className="text-lg leading-relaxed max-w-3xl mx-auto" style={{color: 'rgba(255,255,255,.88)'}}>
            Countless memories. We're just getting started on our journey 
            to bring spontaneous joy to the streets of the Bay Area!
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
